// eslint-disable-next-line import/no-extraneous-dependencies
import 'crypto-js/lib-typedarrays';
import { Auth } from 'aws-amplify';

import { CognitoService } from './cognito-service';
import { IAuthService } from './i-auth-service';

export { AuthException } from './exceptions';

export const authService: IAuthService = new CognitoService(Auth);
